<template>
  <div>
    <div class="mb-3">
      <label class="mb-0 font-lg">Mail acties</label>
      <br />
      <small
        >Vergeet niet eerst de wijzigingen op te slaan, voordat het mailtje
        verstuurd wordt.</small
      >
    </div>

    <div class="mb-4">
      <button
        type="button"
        class="btn btn-primary btn-block"
        @click="setRecipient('guest')"
      >
        Mail versturen naar gast
      </button>
    </div>

    <div class="mb-4">
      <button
        type="button"
        class="btn btn-primary btn-block"
        @click="setRecipient('manager')"
      >
        Mail versturen naar champagnehuis
      </button>
    </div>

    <div class="mb-4">
      <button
        type="button"
        class="btn btn-primary btn-block"
        @click="setRecipient('admin')"
      >
        Mail versturen naar Champagne-Booking
      </button>
    </div>

    <CancellationModal
      :is-cancelled="isCancelled"
      :mails="allMails"
      :booking="booking"
    />

    <MailModal v-model="recipient" :booking="booking" :mails="recipientMails" />
  </div>
</template>

<script>
import MailModal from "./MailModal.vue";
import CancellationModal from "./CancellationModal.vue";

export default {
  components: { MailModal, CancellationModal },
  name: "MailOverview",
  props: {
    value: {
      type: Object,
    },
    recipients: {
      type: Array,
    },
    details: {
      type: Object,
    },
    adminMail: {
      type: String,
    },
  },
  data() {
    return {
      recipient: null,
      booking: { ...this.value },
    };
  },
  methods: {
    setRecipient(type) {
      this.recipient = type;
    },
  },
  computed: {
    isCancelled() {
      let status = this.booking.status;

      return (
        status === "cancelled" ||
        status === "location_cancelled" ||
        status === "location_rejected"
      );
    },
    managerMails() {
      if (!this.recipients || this.recipients.length < 1) {
        return "";
      }

      let mails = this.recipients.map((recipient) => recipient.email);

      return mails.join(", ");
    },
    guestMails() {
      let emails = [this.details.email];

      if (this.details.has_different_main_guest) {
        emails.push(this.details.guest_email);
      }

      return emails.join(", ");
    },
    allMails() {
      let mails = [this.guestMails, this.managerMails, this.adminMail];

      return mails.join(", ");
    },
    recipientMails() {
      switch (this.recipient) {
        case "guest":
          return this.guestMails;
        case "manager":
          return this.managerMails;
        case "admin":
          return this.adminMail;
      }
    },
  },
};
</script>
